import * as i0 from '@angular/core';
import { Directive, Input, Injectable } from '@angular/core';
import * as i1 from '@ng-dot/core';
class DotZoneDirective {
  _renderer;
  set fromSelector(name) {
    if (name) {
      this.name = name;
    }
  }
  set name(value) {
    this._renderer.setProperty(this._host, '.zone', value);
    this._name = value;
  }
  get name() {
    return this._name;
  }
  _host;
  _name;
  constructor(_renderer, elementRef) {
    this._renderer = _renderer;
    this._host = elementRef.nativeElement;
  }
  static ɵfac = function DotZoneDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotZoneDirective)(i0.ɵɵdirectiveInject(i1.DotRendererService), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotZoneDirective,
    selectors: [["", "dotZone", ""]],
    inputs: {
      fromSelector: [0, "dotZone", "fromSelector"],
      name: "name"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotZoneDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[dotZone]'
    }]
  }], () => [{
    type: i1.DotRendererService
  }, {
    type: i0.ElementRef
  }], {
    fromSelector: [{
      type: Input,
      args: ['dotZone']
    }],
    name: [{
      type: Input
    }]
  });
})();
class DotZoneService {
  _renderer;
  constructor(_renderer) {
    this._renderer = _renderer;
  }
  getName(host) {
    const {
      _renderer
    } = this;
    let name;
    let parent = _renderer.parentNode(host);
    let backward = [];
    while (parent?.tagName) {
      name = parent['.zone'];
      if (name) {
        break;
      }
      backward[backward.length] = parent;
      parent = _renderer.parentNode(parent);
    }
    let current = backward.length;
    while (current-- > 0) {
      backward[current]['.zone'] = name;
    }
    return name !== 'null' && name || null;
  }
  static ɵfac = function DotZoneService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotZoneService)(i0.ɵɵinject(i1.DotRendererService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotZoneService,
    factory: DotZoneService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotZoneService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.DotRendererService
  }], null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotZoneDirective, DotZoneService };
